import { createFormAction } from 'redux-form-saga';

export const requestPasswordReset = createFormAction('REQUEST_PASSWORD_RESET');
export const confirmPasswordReset = createFormAction('CONFIRM_PASSWORD_RESET');
